/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

/* ------------------------------------------------------------------
 * Kada: require shoppers to choose a bracelet size before buying.
 * The page still preselects the first variant behind the scenes, so
 * until a size is picked we show "Select your size" and block Add to
 * cart / Shop Pay with a prompt. Skipped when ?variant= is in the URL.
 * ------------------------------------------------------------------ */
(function () {
  if (!document.body || !/\btemplate-product\b/.test(document.body.className)) return;
  if (/[?&]variant=/.test(window.location.search)) return;

  function sizeButton() {
    var items = document.querySelectorAll('.ProductForm__Item');
    for (var i = 0; i < items.length; i++) {
      var name = items[i].querySelector('.ProductForm__OptionName');
      if (name && /size/i.test(name.textContent)) return items[i];
    }
    return null;
  }

  var btn = sizeButton();
  if (!btn) return;

  var wrap = btn.closest('.ProductForm') || document;
  var label = btn.querySelector('.ProductForm__SelectedValue');
  var chosen = false;

  var style = document.createElement('style');
  style.textContent =
    '.kada-needs-size .shopify-payment-button{opacity:.45;pointer-events:none}' +
    '.kada-size-error{display:none;color:#a33a2b;font-size:13px;margin:6px 0 0;letter-spacing:0;text-transform:none}' +
    '.kada-needs-size.kada-show-error .kada-size-error{display:block}' +
    '.kada-needs-size.kada-show-error .ProductForm__Item{border-color:#a33a2b}';
  document.head.appendChild(style);

  if (label) label.textContent = 'Select your size';
  wrap.classList.add('kada-needs-size');

  var err = document.createElement('p');
  err.className = 'kada-size-error';
  err.setAttribute('role', 'alert');
  err.textContent = 'Please choose your size first.';
  var option = btn.closest('.ProductForm__Option');
  if (option) option.appendChild(err);

  function markChosen() {
    chosen = true;
    wrap.classList.remove('kada-needs-size', 'kada-show-error');
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-action="select-value"]') || t.closest('.SizeSwatch')) {
      markChosen();
      return;
    }

    if (chosen) return;

    if (t.closest('[data-action="add-to-cart"]') || t.closest('.ProductForm__AddToCart') || t.closest('.shopify-payment-button')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      wrap.classList.add('kada-show-error');
      btn.scrollIntoView({ behavior: 'smooth', block: 'center' });
      setTimeout(function () { btn.click(); }, 350);
    }
  }, true);

  document.addEventListener('submit', function (e) {
    if (!chosen && e.target && e.target.classList && e.target.classList.contains('ProductForm')) {
      e.preventDefault();
      e.stopImmediatePropagation();
      wrap.classList.add('kada-show-error');
    }
  }, true);

  document.addEventListener('change', function (e) {
    if (e.target && e.target.id && e.target.id.indexOf('product-select-') === 0) markChosen();
  }, true);
})();
